export const shortUserName = (name: string, length: number) => {
    if (name.length > length) {
        return `${name.slice(0, length)}...`;
    } else {
        return name;
    }
};
